import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { useAuth } from 'react-oidc-context';

import type { RequestHandler } from '../../../app/RequestHandler';
import { fetchPrices } from '../pricingSlice';

import type { ProductPrice } from '../interfaces';
import type { LoadingType } from '../../filter/interfaces';
import { getCompanyIdFromFWALayer, getDealerRightsValue } from '../../../utils';

export default function usePricing(requestHandler: RequestHandler): {
  showPriceDataRows: boolean;
  pricesPending: LoadingType;
  standalone: boolean;
} {
  const resultState = useAppSelector((state) => state.filters.shockAbsorbers);
  const { backendPrefix: prefix } = useAppSelector((state) => state.base);

  const token = useAuth().user?.access_token;
  const { language, applicationType } = requestHandler;
  const standalone = applicationType === 'standalone';
  const { error: pricingError, isLoading: pricesPending } = useAppSelector((state) => state.pricing);

  const dispatch = useAppDispatch();

  const showPriceDataRows = pricingError === null;

  useEffect(() => {
    const results = resultState?.shockAbsorbers;
    if (token && results && results.length > 0 && !pricingError) {
      const items: ProductPrice[] = results.map((item, idx) => {
        return {
          item: `00000${idx}`.slice(-6),
          material: item.partNumber.toString(),
          quantity: 1,
          icode1: item.orderCode,
        };
      });
      if (items) {
        const cID = getCompanyIdFromFWALayer();
        const hasDealerRights = getDealerRightsValue();
        if (cID !== 'anonymous' || !hasDealerRights) {
          dispatch(
            fetchPrices({
              items,
              language,
              token,
            }),
          );
        }
      }
    }
  }, [dispatch, token, resultState?.shockAbsorbers, prefix]);

  return { showPriceDataRows, pricesPending, standalone };
}
